import Link from "@/components/ui/Link";
import { sanitizeHTML } from "@/lib/utils";
import BACarousel from "@/components/ui/BACarousel";
import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import FadeIn from '@/components/ui/FadeIn';

interface Images {
  images_id: {
    alt: string;
    image_file: {
      image: {
        id: string;
        filename_download: string;
      };
    };
  };
}

interface FacialSurgeryResultsShowcaseData {
  anchor_title?: string;
  heading?: {
    text?: string;
    title?: string;
  };
  subheading?: {
    text?: string;
    title?: string;
  };
  text?: {
    text?: string;
  };
  images?: Images[];
  button?: {
    href: string;
    label: string;
  };
}

interface FacialSurgeryResultsShowcaseProps {
  data?: FacialSurgeryResultsShowcaseData;
}

export const fields = [
  "anchor_title",
  "heading.text",
  "heading.title",

  "subheading.text",
  "subheading.title",
  "text.text",

  "images.images_id.alt",
  "images.images_id.image_file.image.id",
  "images.images_id.image_file.image.filename_download",

  "button.href",
  "button.label",
] as const;

export default function FacialSurgeryResultsShowcase({
  data,
}: FacialSurgeryResultsShowcaseProps) {
	const { ref, isVisible } = useScrollAnimation()
	const sectionIdBase = data?.anchor_title || 'FacialSurgeryResultsShowcase'
	const sectionId = sectionIdBase
		.replace(/\s+/g, '-')
		.replaceAll(/[^a-zA-Z0-9-_]/g, '-')

  return (
		<section
			ref={ref}
			id={sectionId}
			data-name={data?.anchor_title || 'FacialSurgeryResultsShowcase'}
			className='w-full bg-[#727A7D] py-16'
		>
			<div className='max-w-[1316px] mx-auto'>
				<div className='flex flex-col items-center text-center container'>
					<FadeIn
						isVisible={isVisible}
						delay={0}
						direction='down'
						as='span'
						className='font-aileron font-bold uppercase text-base tracking-[2px] mb-3 text-white'
					>
						<span
							dangerouslySetInnerHTML={sanitizeHTML(
								data?.subheading?.text || data?.subheading?.title || ''
							)}
						/>
					</FadeIn>

					<FadeIn isVisible={isVisible} delay={100} className='text-white'>
						<h2
							dangerouslySetInnerHTML={sanitizeHTML(
								data?.heading?.title || data?.heading?.text || ''
							)}
						/>
					</FadeIn>

					<FadeIn
						isVisible={isVisible}
						delay={200}
						className='text-white mb-10 w-full md:w-1/2 mx-auto'
					>
						<div dangerouslySetInnerHTML={sanitizeHTML(data?.text?.text || '')} />
					</FadeIn>

					<FadeIn isVisible={isVisible} delay={300} className='w-full'>
						<BACarousel images={data?.images || []} />
					</FadeIn>

					{data?.button && (
						<FadeIn className='w-full md:w-auto' isVisible={isVisible} delay={900}>
							<Link href={data.button.href} className='btn mt-10'>
								{data.button.label}
							</Link>
						</FadeIn>
					)}
				</div>
			</div>
		</section>
	)
}
